import { useCallback, useEffect, useRef, useState } from 'react';
import { ScheinStatusValue } from 'types/billingScheinStatus';

export const RESOLVED_BANNER_DURATION_MS = 5_000;

const isProblem = (status?: ScheinStatusValue) =>
  status === ScheinStatusValue.NoSchein || status === ScheinStatusValue.WrongType;

export function useBillingScheinBanner(status?: ScheinStatusValue) {
  const [problemDismissed, setProblemDismissed] = useState(false);
  const [resolved, setResolved] = useState(false);
  const hadProblem = useRef(false);
  const hasProblem = isProblem(status);

  useEffect(() => {
    if (hasProblem) {
      hadProblem.current = true;
      setResolved(false);
    } else if (status === ScheinStatusValue.Ok && hadProblem.current) {
      hadProblem.current = false;
      setProblemDismissed(false);
      setResolved(true);
    }
  }, [hasProblem, status]);

  useEffect(() => {
    if (!resolved) return;
    const timer = setTimeout(() => setResolved(false), RESOLVED_BANNER_DURATION_MS);
    return () => clearTimeout(timer);
  }, [resolved]);

  const view: 'problem' | 'resolved' | null =
    hasProblem && !problemDismissed ? 'problem' : resolved ? 'resolved' : null;

  const dismiss = useCallback(() => {
    if (hasProblem) setProblemDismissed(true);
    else setResolved(false);
  }, [hasProblem]);

  return { view, dismiss };
}
